import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { HttpService } from '../services/http.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { global_variables } from '../../environments/global_variables';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

import { tRowLabel, valvePumpCellText, viewTKeyTables, viewValvePumpKeyTable } from '../helpers/config-view-rows';
import { OMNI_30XX_MODAL_TYPE, isOmni2100FamilyModalType } from '../helpers/sensor-type-names';

@Component({
   selector: 'app-configure',
   templateUrl: './configure.component.html',
   styleUrls: ['./configure.component.scss'],
})
export class ConfigureComponent implements OnInit, OnDestroy {
   readonly tRowLabel = tRowLabel;
   readonly valvePumpCellText = valvePumpCellText;

   get isOmni2100Family(): boolean {
      return isOmni2100FamilyModalType(this.nModalType);
   }

   get isOmni30xx(): boolean {
      return this.nModalType === OMNI_30XX_MODAL_TYPE;
   }

   configurationSub: Subscription;
   paramSub: Subscription;
   bIsLoadData: boolean;
   strCurrentDataType: string;
   strConfigurationFileName: string;
   strCurrentUserType: string;
   objValuePumpKeyTable: Object;

   arrBIsConfig: boolean[];
   arrStrStepActions: string[];
   arrStrUserTypes: string[];
   arrStrDataTypes: string[];
   arrIntModalTypes: number[];
   arrObjConfigData: Object[];
   arrObjTKeyTable: Object[];

   nModalType: number;

   constructor(
      private _httpService: HttpService,
      private _authService: AuthService,
      private _route: ActivatedRoute,
      private _router: Router,
      private _snackBar: MatSnackBar,
      private _location: Location
   ) {
      this.nModalType = -1;
      this.bIsLoadData = false;
      this.arrStrStepActions = global_variables['stepActions'];
      this.arrStrDataTypes = global_variables['DataTypes'];
      this.arrStrUserTypes = global_variables['userTypes'];
      this.arrIntModalTypes = global_variables['modalTypes'];
      this.arrBIsConfig = [];
      this.arrObjConfigData = [];
      this.arrObjTKeyTable = [];
      this.strConfigurationFileName = '';
      this.objValuePumpKeyTable = {};
   }

   /**
    * convert seconds to time
    * @param secs seconds
    */
   secondsToTime(secs: number) {
      const hours = Math.floor(secs / (60 * 60));

      const divisor_for_minutes = secs % (60 * 60);
      const minutes = Math.floor(divisor_for_minutes / 60);

      const divisor_for_seconds = divisor_for_minutes % 60;
      const seconds = Math.ceil(divisor_for_seconds);

      let res = '';

      if (minutes === 0 && seconds === 0) {
         res += `${hours} hours`;
      } else {
         if (hours > 0) {
            res += `${hours} hours `;
         }

         res += `${minutes} minutes`;

         if (seconds > 0) {
            res += ` ${seconds} seconds`;
         }
      }

      return res;
   }

   /**
    * make the configuration table to display
    * @param objConfigData configuration data
    * @param nDataType data type
    */
   setConfigData(objConfigData: Object, nDataType: number) {
      const strDataType = this.arrStrDataTypes[nDataType];
      this.strCurrentDataType = strDataType;

      this.arrObjConfigData[nDataType]['Num_of_Step'] = objConfigData[strDataType]['Num_of_Step'];
      this.arrObjConfigData[nDataType]['Num_of_Cycle'] = objConfigData[strDataType]['Num_of_Cycle'];
      this.arrObjConfigData[nDataType]['Sampling_Time'] = this.secondsToTime(
         objConfigData[strDataType]['Sampling_Time']
      );
      this.arrObjConfigData[nDataType]['Idle_Time'] = objConfigData[strDataType]['Idle_Time'];
      const data = [];

      for (let i = 1; i <= parseInt(this.arrObjConfigData[nDataType]['Num_of_Step'], 10); i++) {
         const stepKey = `Step${i}_Config`;
         if (objConfigData[strDataType]['Mode_Config']) {
            data.push(objConfigData[strDataType]['Mode_Config'][stepKey]);
         }
      }

      this.arrObjConfigData[nDataType]['data'] = data;
      this.arrBIsConfig[nDataType] = true;
      console.log(this.arrObjConfigData);
   }

   ngOnInit() {
      if (this._authService.isUserEmailLoggedIn && this._authService.currentUserId) {
         if (this._authService.isUserStaff) {
            // staff
            this.strCurrentUserType = this.arrStrUserTypes[0];
         } else {
            // customer
            this.strCurrentUserType = this.arrStrUserTypes[1];
         }

         this.arrObjTKeyTable = viewTKeyTables(this.nModalType);
         this.objValuePumpKeyTable = viewValvePumpKeyTable(this.nModalType);

         this.paramSub = this._route.params.subscribe({
            next: (params) => {
               const sensorKey = params['sensorKey'];
               if (this.configurationSub) {
                  this.configurationSub.unsubscribe();
               }

               this.configurationSub = this._httpService
                  .getAsObject(`${environment.APIS.SENSORCONFIGS}/${sensorKey}`)
                  .subscribe({
                     next: (config: Object) => {
                        this.arrBIsConfig = [];
                        this.arrObjConfigData = [];

                        if (config && config['Current_Modal_Type'] !== null) {
                           this.nModalType = config['Current_Modal_Type'];
                           const configData = config[config['Current_Modal_Type']];
                           for (let i = 0; i < this.arrStrDataTypes.length; i++) {
                              this.arrObjConfigData[i] = <any>{};
                              this.arrBIsConfig[i] = false;

                              if (configData && configData.hasOwnProperty(this.arrStrDataTypes[i])) {
                                 this.setConfigData(configData, i);
                              }
                           }
                        }

                        // Rebuilt on every emission so live config updates never stack rows.
                        this.arrObjTKeyTable = viewTKeyTables(this.nModalType);
                        this.objValuePumpKeyTable = viewValvePumpKeyTable(this.nModalType);

                        this.strConfigurationFileName = config['File_Name'];
                        this.bIsLoadData = true;
                     },
                     error: error => {
                        console.error('configure.component.ts -> this.configurationSub:', error);
                     }
                  });
            },
            error: error => {
               console.error('configure.component.ts -> this.paramSub', error);
            }
         });
      } else {
         this._snackBar.open("You don't have right permission.", 'Alert', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center',
         });
         this._router.navigate(['/dashboard']);
      }
   }

   ngOnDestroy() {
      if (this.paramSub) {
         this.paramSub.unsubscribe();
      }

      if (this.configurationSub) {
         this.configurationSub.unsubscribe();
      }
   }

   onBack() {
      this._location.back();
   }
}
